import { render } from "./PanelsGroup.vue?vue&type=template&id=9891b386&scoped=true"
import script from "./PanelsGroup.vue?vue&type=script&lang=js"
export * from "./PanelsGroup.vue?vue&type=script&lang=js"

import "./PanelsGroup.vue?vue&type=style&index=0&id=9891b386&scoped=true&lang=scss"
import "./PanelsGroup.vue?vue&type=style&index=1&id=9891b386&lang=scss"

import exportComponent from "/codebuild/output/src3025396533/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9891b386"]])

export default __exports__